<app-header [hideBackButton]="true"></app-header>
<ion-content
  *ngIf="(listsPageData$ | async) as listsPageData"
  id="lists"
  class="gray-content-bg"
  [ngClass]="(platformService?.isTouchExperience$ | async) ? platformService?.platformType === 'tablet' ? 'tablet' : 'mobile' : 'desktop'"
>
  <ng-container
    *ngIf="!!listsPageData?.isListDataLoaded else listLandingSkeleton"
  >
    <app-page-title-banner
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
      [pageTitle]="pageTitle"
      [backgroundImageStyle]="backgroundImageStyle"
      [overlayGradient]="overlayGradient"
      [showEllipsis]="false"
    ></app-page-title-banner>

    <ng-container *ngIf="listsPageData?.isListDataLoaded">
      <!-- Desktop/Tablet -->
      <ng-container
        *ngIf="platformService?.platformType !==
        platformService?.platformEnum?.mobile; else mobileLists"
      >
        <ion-grid [fixed]="true">
          <!--list Updates Section Start-->
          <ion-row
            data-cy="list-update-notification-row-desktop"
            class="list-update-notification"
            *ngIf="listUpdatesExist$ | async"
          >
            <ion-col
              class="text-icon-container"
              data-cy="list-update-notification-col-desktop"
              (click)="goToListUpdates()"
            >
              <div
                data-cy="list-update-notification-icon-container-desktop"
                class="green-filled-notification-icon"
              >
                <ion-icon
                  data-cy="list-update-notification-icon-desktop"
                  src="assets/icon/alert-icon-green-filled.svg"
                />
              </div>
              <div
                data-cy="list-update-notification-text-container-desktop"
                class="list-update-text"
              >
                <span>
                  {{ 'i18n.lists.listUpdatesNotification' | translate }}
                </span>
              </div>
            </ion-col>
          </ion-row>

          <!--list Updates Section End-->
          <!-- Searchbar and Create a List -->
          <ion-row
            data-cy="lists-page-header-row"
            class="lists-page-header-row"
          >
            <ion-col data-cy="lists-page-header-column" size="3.5">
              <ion-searchbar
                data-cy="lists-page-searchbar-input"
                class="search"
                mode="md"
                placeholder="{{ 'i18n.lists.searchByListName' | translate }}"
                [(ngModel)]="searchKey"
                (ionInput)="!searchKey ? resetSearch() : search()"
                (ionClear)="resetSearch()"
              ></ion-searchbar>
            </ion-col>
            <ion-col size="2.5">
              <ion-button
                [hidden]="(addProductsFeatureFlag$ | async) === false || listsPageData?.numberOfEditableLists === 0"
                id="add-products-btn"
                data-cy="add-products-btn"
                class="usf-outline-green-button add-products-button"
                (click)="openAddProducts()"
                >{{ 'i18n.common.addProducts' | translate }}<ion-icon
                  slot="end"
                  name="chevron-down-outline"
                ></ion-icon
              ></ion-button>
              <!-- Add Products Popover-->
              <ion-popover
                *ngIf="platformService?.platformType === platformService?.platformEnum.desktop"
                data-cy="add-products-popover"
                class="add-products-popover"
                mode="ios"
                showBackdrop="false"
                trigger="add-products-btn"
                dismissOnSelect="true"
              >
                <ng-template>
                  <app-ellipsis-options-popover
                    class="popover-viewport"
                    [buttons]="addProductsButtons$ | async"
                  ></app-ellipsis-options-popover>
                </ng-template>
              </ion-popover>
            </ion-col>
            <ion-col data-cy="lists-page-header-column" size="6">
              <div
                data-cy="lists-page-buttons-section"
                class="lists-page-buttons"
              >
                <ion-button
                  *ngIf="listsPageData"
                  data-cy="lists-page-create-list-button"
                  class="usf-fill-green-button"
                  (click)="openCreateListModal(listsPageData)"
                >
                  {{ 'i18n.lists.createAList' | translate }}
                  <ion-icon
                    *ngIf="platform === 'desktop'"
                    name="chevron-down"
                    class="create-list-chevron"
                  ></ion-icon>
                </ion-button>
              </div>
            </ion-col>
          </ion-row>
          <!-- Lists (Non Internal User) -->
          <ng-container *ngIf="listsPageData?.userKind !== userKinds.Internal">
            <!-- Last Viewed Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'recentlyViewedLists'"
              [sectionTitle]="'i18n.lists.lastViewed' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.recentlyViewedLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.recentlyViewedLists"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Favorites List -->
            <app-list-section-desktop-tablet
              *ngIf="listsPageData?.customerHasFavorites && (addToFavoritesFlag$ | async)"
              [sectionName]="'favoritesList'"
              [sectionTitle]="'i18n.lists.favorites' | translate"
              [sectionHeaders]="[]"
              [lists]="listsPageData?.lists?.favoritesList"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Public Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'publicLists'"
              [sectionTitle]="'i18n.lists.myShoppingLists' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.publicLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.publicLists?.selectedHeader"
              [lists]="listsPageData?.lists?.publicLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Manage By USF Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'managedByUsfLists'"
              [sectionTitle]="'i18n.lists.managedByUsf' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.managedByUsfLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.managedByUsfLists?.selectedHeader"
              [lists]="listsPageData?.managedByUsfLists"
              [recentlyPurchasedCount]="listsPageData?.recentlyPurchasedCount"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
          </ng-container>
          <!-- Lists (Internal User) -->
          <ng-container *ngIf="listsPageData?.userKind === userKinds.Internal">
            <!-- Last Viewed Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'recentlyViewedLists'"
              [sectionTitle]="'i18n.lists.lastViewed' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.recentlyViewedLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.recentlyViewedLists"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Favorites List -->
            <app-list-section-desktop-tablet
              *ngIf="listsPageData?.customerHasFavorites && (addToFavoritesFlag$ | async)"
              [sectionName]="'favoritesList'"
              [sectionTitle]="'i18n.lists.favorites' | translate"
              [sectionHeaders]="[]"
              [lists]="listsPageData?.lists?.favoritesList"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Public Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'publicLists'"
              [sectionTitle]="'i18n.lists.public' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.publicLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.publicLists?.selectedHeader"
              [lists]="listsPageData?.lists?.publicLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Internal Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'internalLists'"
              [sectionTitle]="'i18n.lists.internal' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.internalLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.internalLists?.selectedHeader"
              [lists]="listsPageData?.lists?.internalLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Private Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'privateLists'"
              [sectionTitle]="'i18n.lists.private' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.privateLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.privateLists?.selectedHeader"
              [lists]="listsPageData?.lists?.privateLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
            <!-- Managed by USF Lists -->
            <app-list-section-desktop-tablet
              [sectionName]="'managedByUsfLists'"
              [sectionTitle]="'i18n.lists.managedByUsf' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.managedByUsfLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.managedByUsfLists?.selectedHeader"
              [lists]="listsPageData?.managedByUsfLists"
              [recentlyPurchasedCount]="listsPageData?.recentlyPurchasedCount"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [listDownloadModalRef]="listDownloadModal"
              [listPrintModalRef]="listPrintModal"
            >
            </app-list-section-desktop-tablet>
          </ng-container>
        </ion-grid>
      </ng-container>

      <!-- Mobile -->
      <ng-template #mobileLists>
        <ion-grid [fixed]="true">
          <!--list Update Section Start-->
          <ion-row
            data-cy="list-update-notification-row-mobile"
            class="list-update-notification"
            *ngIf="listUpdatesExist$ | async"
          >
            <ion-col
              class="text-icon-container"
              data-cy="list-update-notification-col-mobile"
              (click)="goToListUpdates()"
            >
              <div
                data-cy="list-update-notification-icon-container-mobile"
                class="green-filled-notification-icon"
              >
                <ion-icon
                  data-cy="list-update-notification-icon-mobile"
                  src="assets/icon/alert-icon-green-filled.svg"
                />
              </div>
              <div
                data-cy="list-update-notification-text-col-mobile"
                class="list-update-text"
              >
                <span>
                  {{ 'i18n.lists.listUpdatesNotification' | translate }}
                </span>
              </div>
            </ion-col>
          </ion-row>

          <!--list Update Section End-->
          <!-- Searchbar, Close Search, and Sort -->
          <ion-row
            data-cy="lists-page-header-row"
            class="lists-page-header-row"
          >
            <ion-col size="10">
              <ion-searchbar
                data-cy="lists-page-searchbar-input"
                class="search"
                mode="md"
                placeholder="{{ 'i18n.lists.searchByListName' | translate }}"
                [(ngModel)]="searchKey"
                (ionInput)="!searchKey ? resetSearch() : search()"
                (ionClear)="resetSearch()"
              >
              </ion-searchbar>
            </ion-col>
            <ion-col size="2">
              <ion-icon
                data-cy="lists-page-open-sort-button"
                class="lists-page-button"
                name="options-outline"
                (click)="openMobileSort(listsPageData?.listOfListsSort?.publicLists?.headers)"
              ></ion-icon>
            </ion-col>
          </ion-row>
          <ion-row class="mobile-button-row">
            <ion-col
              *ngIf="(addProductsFeatureFlag$ | async) === true && listsPageData?.numberOfEditableLists > 0"
              size="6"
            >
              <ion-button
                class="usf-outline-green-button add-products-button-mobile"
                (click)="openAddProducts()"
                >{{ 'i18n.common.addProducts' | translate }}<ion-icon
                  slot="end"
                  name="chevron-down-outline"
                ></ion-icon
              ></ion-button>
            </ion-col>
            <ion-col size="6">
              <ion-button
                *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile && (listsPageData$ | async) as listsPageData"
                data-cy="lists-page-create-list-button"
                class="usf-fill-green-button create-list-button-mobile"
                (click)="openCreateListModal(listsPageData)"
              >
                {{ 'i18n.lists.createAList' | translate }}
              </ion-button>
            </ion-col>
          </ion-row>
          <!-- Lists (Non Internal User) -->
          <ng-container *ngIf="listsPageData?.userKind !== userKinds.Internal">
            <!-- Last Viewed Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.lastViewed' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.recentlyViewedLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.recentlyViewedLists"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Favorites List -->
            <app-list-section-mobile
              *ngIf="listsPageData?.customerHasFavorites && (addToFavoritesFlag$ | async)"
              [sectionTitle]="'i18n.lists.favorites' | translate"
              [sectionHeaders]="[]"
              [lists]="listsPageData?.lists?.favoritesList"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Public Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.myShoppingLists' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.publicLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.publicLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Managed By USF Lists -->
            <app-list-section-mobile
              [sectionTitle]="managedByUsfSectionTitle"
              [sectionHeaders]="listsPageData?.listOfListsSort?.managedByUsfLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.managedByUsfLists"
              [recentlyPurchasedCount]="listsPageData?.recentlyPurchasedCount"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
          </ng-container>
          <!-- Lists (Internal User) -->
          <ng-container *ngIf="listsPageData?.userKind === userKinds.Internal">
            <!-- Last Viewed Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.lastViewed' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.recentlyViewedLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.recentlyViewedLists"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Favorites List -->
            <app-list-section-mobile
              *ngIf="listsPageData?.customerHasFavorites && (addToFavoritesFlag$ | async)"
              [sectionTitle]="'i18n.lists.favorites' | translate"
              [sectionHeaders]="[]"
              [lists]="listsPageData?.lists?.favoritesList"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Public Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.public' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.publicLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.publicLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Internal Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.internal' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.internalLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.internalLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Private Lists -->
            <app-list-section-mobile
              [sectionTitle]="'i18n.lists.private' | translate"
              [sectionHeaders]="listsPageData?.listOfListsSort?.privateLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.lists?.privateLists"
              [massDeleteModalRef]="massDeleteModal"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
            <!-- Managed by USF Lists -->
            <app-list-section-mobile
              [sectionTitle]="managedByUsfSectionTitle"
              [sectionHeaders]="listsPageData?.listOfListsSort?.managedByUsfLists?.headers"
              [selectedHeader]="listsPageData?.listOfListsSort?.recentlyViewedLists?.selectedHeader"
              [lists]="listsPageData?.managedByUsfLists"
              [recentlyPurchasedCount]="listsPageData?.recentlyPurchasedCount"
              [masterListItemsAreLoaded]="listsPageData?.masterListItemsAreLoaded"
              [listDownloadModalRef]="listDownloadModal"
            >
            </app-list-section-mobile>
          </ng-container>
        </ion-grid>
      </ng-template>
    </ng-container>
    <app-import-list-modal-container
      (submitEvent)="listsService.handleImportSubmission($event)"
      (listTemplateEvent)="listsService.getListTemplate()"
      [listPageData]="listsPageData"
      [translateService]="translateService"
    >
    </app-import-list-modal-container>
    <!-- Download List Modal -->
    <app-list-download-container
      [translateService]="translateService"
      (submitEvent)="downloadList($event)"
      [hidePricingOption]="(selectedCustomer$ | async).ogPrintPriceInd === 'N'"
    ></app-list-download-container>
    <!-- Print List Modal -->
    <app-list-print-container
      [translateService]="translateService"
      (submitEvent)="downloadList($event)"
    ></app-list-print-container>
    <app-footer></app-footer>
  </ng-container>
</ion-content>

<!-- Create List Button for Mobile -->

<!-- Floating Tooltip for My Lists -->
<div class="help-icon">
  <img
    data-cy="lists-page-open-help-modal-button"
    src="assets/icon/custom-help-tooltip.svg"
    (click)="openHelpModal()"
  />
</div>

<!-- Download list modal-->
<ion-modal
  [isOpen]="listsOverlayService?.listDownloadModalOptions$?.value?.isOpen"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (ionModalDidDismiss)="closeDownloadListModal()"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' : (listsOverlayService?.listDownloadModalOptions$?.value?.isDownload ? 'modal-desktop-size-lg' : 'download-print-desktop')"
>
  <ng-template>
    <app-download-list-v2
      class="ion-page"
      [platformType]="platformService?.platformType"
      [listName]="listsOverlayService?.listDownloadModalOptions$?.value?.listName"
      [listId]="listsOverlayService?.listDownloadModalOptions$?.value?.listId"
      [listTypeId]="listsOverlayService?.listDownloadModalOptions$?.value?.listTypeId"
      [isDownload]="listsOverlayService?.listDownloadModalOptions$?.value?.isDownload"
      [hidePricingOption]="(selectedCustomer$ | async).ogPrintPriceInd === 'N'"
      (dismissEvent)="closeDownloadListModal()"
      (downloadEmitter)="downloadList($event)"
    >
    </app-download-list-v2>
  </ng-template>
</ion-modal>

<!-- Add Products Action sheet-->
<ion-action-sheet
  class="action-sheet-touch"
  mode="ios"
  data-cy="add-products-action-sheet"
  [isOpen]="addProductsActionSheetIsOpen"
  [buttons]="addProductsButtons$ | async"
  (didDismiss)="addProductsActionSheetIsOpen = false"
></ion-action-sheet>

<!-- Mass Delete Modal -->
<app-mass-delete-dual-pane-container></app-mass-delete-dual-pane-container>

<!-- Lists Landing Page Skeleton -->
<ng-template #listLandingSkeleton>
  <ion-content>
    <app-list-landing-skeleton
      [platform]="platform"
    ></app-list-landing-skeleton>
    <app-footer></app-footer>
  </ion-content>
</ng-template>

<!-- AI List Builder Modal -->
<ion-modal
  [isOpen]="listsOverlayService.aiListBuilderModalIsOpen$ | async"
  [ngClass]="platformService.platformType !== platformService.platformEnum.desktop ? 'ion-modal-touch' :'modal-desktop-size-xl'"
  [initialBreakpoint]="platformService.platformType !== platformService.platformEnum.desktop ? 1 : undefined"
  [breakpoints]="platformService.platformType !== platformService.platformEnum.desktop  ? [0, 1] : undefined"
  (didDismiss)="listsOverlayService.closeAiListBuilderModal();clearAiListPhotosAndErrors();"
>
  <ng-template>
    <app-ai-list-builder-modal
      class="ion-page"
      [platform]="platformService.platformType"
      [menuTypes]="aiListMetaDataService.menuTypes$ | async"
      [listNameBlackList]="listNameBlackList$ | async"
      (dismissed)="listsOverlayService.closeAiListBuilderModal()"
      (submitted)="createAiList($event)"
      [dismissPromise]="dismissPromise"
    >
    </app-ai-list-builder-modal>
  </ng-template>
</ion-modal>

<!-- New Search list modal -->
<app-new-search-simple-modal
  [isOpen]="isSearchModalOpen"
  (executeSearchEmitter)="handleSimpleSearchModalEvent($event)"
>
</app-new-search-simple-modal>

<!-- Add to list modal-->
<ion-modal
  [isOpen]="this.addToListModalService.isModalOpen$ | async"
  (ionModalDidDismiss)="this.addToListModalService.closeModal()"
  [class]="
  (platformService?.isTouchExperience$ | async)
    ? 'ion-modal-touch'
    : 'modal-desktop-size-xl'
"
  [initialBreakpoint]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? 1
    : undefined
"
  [breakpoints]="
  platformService?.platformType !== platformService?.platformEnum.desktop
    ? [0, 1]
    : undefined
"
  id="addToListModal"
>
  <ng-template>
    <app-modal-with-nav-inline
      [rootPage]="this.addToListModalService.dualPaneRef"
      [rootPageParams]="this.addToListModalService.dualPaneModalData"
    >
    </app-modal-with-nav-inline>
  </ng-template>
</ion-modal>
